import { render } from "./HowItWorksVideo.vue?vue&type=template&id=406614de&scoped=true"
import script from "./HowItWorksVideo.vue?vue&type=script&lang=js"
export * from "./HowItWorksVideo.vue?vue&type=script&lang=js"

import "./HowItWorksVideo.vue?vue&type=style&index=0&id=406614de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-406614de"

export default script